import { createAction } from '../../../../store.model';
import { ChatMessage } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

export interface ReceiveMessages {
    messages: ChatMessage[];
}

export const receiveMessages = createAction<ActionType, ReceiveMessages>(
    ActionType.COACHING_DETAIL__TCD__RECEIVE_MESSAGES,
);
